export enum policyEffects {
  ALLOW = 'allow',
  DENY = 'deny',
}

export enum permissionSubGroups {
  READ = 'read',
  WRITE = 'write',
  OTHER = 'other',
}
